import script from "./AssetGraphItem.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetGraphItem.vue?vue&type=script&setup=true&lang=js"

import "./AssetGraphItem.vue?vue&type=style&index=0&id=51634977&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51634977"]])

export default __exports__